import {useCallback, useEffect} from 'react'

import {useStoredSettingsValue} from '../../../../../../../contexts/StoredSettingsValue/StoredSettingsValueContext'
import type {Step} from '../../../../../../../types'

function useJobStepsStoredValue(steps: Step[], jobId: string) {
  const {setValueToStoredSettings, getValueFromStoredSettings} = useStoredSettingsValue()
  const getJobStepsStoredId = useCallback((index: number) => `${jobId}_${index}`, [jobId])
  const addStoredJobStep = useCallback(
    (jobStep: Step, index: number) => {
      const jobStepsStoredKey = `${getJobStepsStoredId(index)}_${jobStep.type}`
      setValueToStoredSettings(jobStepsStoredKey, jobStep)
    },
    [getJobStepsStoredId, setValueToStoredSettings],
  )
  const getStoredJobStep = useCallback(
    (type: string, index: number): Step | undefined => {
      const jobStepsStoredId = `${getJobStepsStoredId(index)}_${type}`
      const storedValue = getValueFromStoredSettings(jobStepsStoredId)

      return storedValue as Step
    },
    [getJobStepsStoredId, getValueFromStoredSettings],
  )

  useEffect(() => {
    steps.forEach(addStoredJobStep)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [jobId])

  return {
    addStoredJobStep,
    getStoredJobStep,
  }
}

export default useJobStepsStoredValue
